var App = App || {};

App.SolutionsBand = (function ($) {
    'use strict';

    var $slides;

    function init() {
        $slides = $('.solutions__container');

        if (ZAGFramework.GetCurrentBP() == "xxl" || ZAGFramework.GetCurrentBP() == "xl" || ZAGFramework.GetCurrentBP() == "lg") {
            Slick(5);
            if ($(".solutions__item").length > 5) {
                showControls();
            }
        }

        if (ZAGFramework.GetCurrentBP() == "xs" || ZAGFramework.GetCurrentBP() == "sm" || ZAGFramework.GetCurrentBP() == "md") {
            Slick(3);
        }

        $(document).bind("enter-xxl enter-xl enter-lg", function () {
            Slick(5);
          
        });

        $(document).bind("enter-md enter-sm enter-xs", function () {
            Slick(3);
        });
    }

    function showControls() {
        $(".controls").attr("tabindex", "0");
    }

    function hideControls() {
        $(".controls").attr("tabindex", "-1");
    }

    function Slick(CarouselCount) {
        if ($slides.hasClass("slick-initialized") == true) {
            $slides.slick("unslick");
        }
        $slides.each(function () {

            if ($(this).hasClass("slick-initialized") == true) {
                $(this).slick("unslick");
            }

            $(this).slick({
                adaptiveHeight: true,
                autoplay: false,
                dots: false,
                arrows: true,
                centerMode: false,
                prevArrow: $('.solutions-list__wrapper .slide-prev'),
                nextArrow: $('.solutions-list__wrapper .slide-next'),
                draggable: false,
                infinite: true,
                slidesToShow: CarouselCount,
                slidesToScroll: 1
            });
        });

        setTimeout(
            function () {
                $('.solutions').removeClass("cloak");
            }, 150);

        

    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.SolutionsBand.init();
});